import type { FoldableType } from '../../../types/menu';

export const MIN_ITEMS = 4;

export function getFoldableThreshold(foldable: FoldableType | undefined) {
	return typeof foldable === 'number' ? foldable : MIN_ITEMS;
}

export function hasEnhancedMoreButton(foldable: FoldableType | undefined, itemLength: number): boolean {
	return (
		typeof foldable === 'number' &&
		itemLength > getFoldableThreshold(foldable));
}

export function hasLegacyMoreButton(foldable: FoldableType | undefined, itemLength: number): boolean {
	return foldable === true && itemLength > getFoldableThreshold(foldable);
}

export function hasMoreButton(foldable: FoldableType | undefined, itemLength: number): boolean {
	return hasEnhancedMoreButton(foldable, itemLength) || hasLegacyMoreButton(foldable, itemLength);
}
